import { render, staticRenderFns } from "./LoginEmail.vue?vue&type=template&id=1bfc498c&scoped=true&"
import script from "./LoginEmail.vue?vue&type=script&lang=js&"
export * from "./LoginEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoginEmail.vue?vue&type=style&index=0&id=1bfc498c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc498c",
  null
  
)

export default component.exports